import React from 'react';
import { Phone, Sparkles } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Hero = () => {
  const handleWhatsAppClick = () => {
    window.open(
      `https://wa.me/${contactInfo.whatsapp}?text=Olá! Gostaria de agendar um horário para extensão de cílios.`,
      '_blank'
    );
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center hero-gradient overflow-hidden"
    >
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-[var(--color-rose-gold-light)] rounded-full opacity-10 blur-3xl animate-float" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[var(--color-nude)] rounded-full opacity-20 blur-3xl" style={{ animationDelay: '1s' }} />
      
      {/* Content */}
      <div className="container mx-auto px-6 pt-24 pb-16 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Main Title */}
          <h1 
            className="text-5xl md:text-6xl lg:text-7xl font-medium text-[var(--color-brown-dark)] mb-6 animate-fade-in-up"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            Jani Ribeiro
          </h1>
          
          <p 
            className="text-xl md:text-2xl text-[var(--color-rose-gold-dark)] uppercase tracking-[0.3em] mb-8 animate-fade-in-up"
            style={{ fontFamily: 'var(--font-body)', animationDelay: '0.1s' }}
          >
            Lash Designer
          </p>

          {/* Subtitle */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="decorative-line" />
            <p 
              className="text-2xl md:text-3xl text-[var(--color-brown)] mt-6 mb-10"
              style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic' }}
            >
              A arte de realçar o seu olhar
            </p>
          </div>

          {/* Features */}
          <div 
            className="flex flex-wrap justify-center gap-6 mb-12 animate-fade-in-up"
            style={{ animationDelay: '0.3s' }}
          >
            {['Técnicas Exclusivas', 'Produtos Premium', 'Conforto Garantido'].map((feature, index) => (
              <div 
                key={index}
                className="flex items-center gap-2 text-[var(--color-text-light)] text-sm uppercase tracking-wider"
              >
                <Sparkles size={14} className="text-[var(--color-rose-gold)]" />
                {feature}
              </div>
            ))}
          </div>

          {/* CTA Button - Only WhatsApp */}
          <div 
            className="flex justify-center animate-fade-in-up"
            style={{ animationDelay: '0.4s' }}
          >
            <button
              onClick={handleWhatsAppClick}
              className="btn-primary flex items-center justify-center gap-3 animate-pulse-soft px-10 py-5 text-lg"
            >
              <Phone size={22} />
              Agendar via WhatsApp
            </button>
          </div>

          {/* Business Hours Note */}
          <p 
            className="text-sm text-[var(--color-text-light)] mt-10 animate-fade-in"
            style={{ animationDelay: '0.5s' }}
          >
            Atendimento com horário flexível • Agende seu horário
          </p>
        </div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
